"use strict";
exports.__esModule = true;
var basic_table_component_1 = require("../../../../basic-component/basic-table.component");
var smartorg;
(function (smartorg) {
    var r6;
    (function (r6) {
        var acts;
        (function (acts) {
            var addTables;
            (function (addTables) {
                var gridLogic;
                (function (gridLogic) {
                    function formatCell(val) {
                        return (val !== '') ? isNaN(val) ? val : Number(val) : val;
                    }
                    var modifyGridColHeaderForTooltip = function (displayRules, gridColumnHeaders) {
                        if (displayRules) {
                            for (var i = 0; i < displayRules.length; i++) {
                                if ((gridColumnHeaders.indexOf(displayRules[i]['ColHeader']) !== -1) &&
                                    ('Rule' in displayRules[i]) &&
                                    (displayRules[i]['Rule'] == "TOOLTIP")) {
                                    var index = gridColumnHeaders.indexOf(displayRules[i]['ColHeader']);
                                    gridColumnHeaders[index] = gridColumnHeaders[index] + " (?)";
                                }
                            }
                        }
                    };
                    function makeSingleTable(tableData, options, colorByList, colors, shadowColor, displayRules) {
                        if (colorByList === void 0) { colorByList = undefined; }
                        if (colors === void 0) { colors = undefined; }
                        if (shadowColor === void 0) { shadowColor = undefined; }
                        if (displayRules === void 0) { displayRules = undefined; }
                        var gridOptions = {};
                        var gridColumnHeaders = tableData.colHeader.map(function (item, index) {
                            if (index == 0 && item == "") {
                                return item = "Project";
                            }
                            return item;
                        });
                        modifyGridColHeaderForTooltip(displayRules, gridColumnHeaders);
                        var fixedHeaderCount = 1;
                        var timestamp = options.timestampMode === 'lastRecalc' ? options.timestamp : null;
                        var colDef = gridColumnHeaders.map(function (header, index) {
                            var d = {
                                enableHiding: false,
                                enableSorting: options.enableSorting,
                                name: header,
                                displayName: header == "Project" ? "" : header,
                                headerTooltip: function (row) {
                                    return getHeaderTooltip(displayRules, row);
                                },
                                field: index.toString(),
                                cellClass: header == "Project" ? "grid-row-header" : undefined,
                                width: index < fixedHeaderCount ? 200 : 100,
                                pinnedLeft: index < fixedHeaderCount,
                                cellFilter: index < fixedHeaderCount ? '' : 'tableNumber: col.colDef.filterFormat',
                                grouping: index == 0 ? { groupPriority: index } : undefined,
                                cellTemplate: '<div class="ui-grid-cell-contents">' +
                                    '<div ng-if="grid.appScope.isNaN(COL_FIELD)">' +
                                    '{{COL_FIELD}}' +
                                    '</div>' +
                                    '<div  ng-if="!grid.appScope.isNaN(COL_FIELD)">' +
                                    '{{COL_FIELD || COL_FIELD CUSTOM_FILTERS}}' +
                                    '</div>' +
                                    '</div>'
                            };
                            if (options.numDecimals !== "Default") {
                                d['filterFormat'] = options.numDecimals;
                            }
                            for (var index_1 in displayRules) {
                                if (displayRules.hasOwnProperty(index_1)) {
                                    if (header == displayRules[index_1]["ColHeader"]) {
                                        if (displayRules[index_1]["Rule"] == "YEAR" || displayRules[index_1]["RULE"] == "YEAR")
                                            d['cellFilter'] = "";
                                    }
                                }
                            }
                            return d;
                        });
                        var gridData = [];
                        tableData.lines.forEach(function (line, index) {
                            var rollup = { $$treeLevel: 0 };
                            var lineIsEmpty = line.rolledUpLine.join('').trim() === '';
                            if (index == 50) {
                                console.log(line);
                            }
                            if (!lineIsEmpty) {
                                line.rolledUpLine.forEach(function (item, colIndex) {
                                    //rollup[index.toString()] = formatCell(item);
                                    var allChildrenEmpty = line.children.every(function (child) {
                                        return child[colIndex] === null || child[colIndex] === "";
                                    });
                                    // If all child values are empty, set the rolled-up value to ""
                                    rollup[colIndex.toString()] = allChildrenEmpty ? "" : formatCell(item);
                                });
                            }
                            gridData.push(rollup);
                            var lineColors = 'colors' in line ? line.colors : null; // When colorBy and groupBy are different
                            if (!lineIsEmpty) {
                                line.children.forEach(function (child, index) {
                                    var c = { $$treeLevel: 1 };
                                    child.forEach(function (item, index) {
                                        c[index.toString()] = formatCell(item);
                                    });
                                    if (lineColors) {
                                        // When colorBy and groupBy are different
                                        for (var i = 0; i < lineColors.length; i++) {
                                            if (child[0] == lineColors[i]['name']) {
                                                c['color'] = lineColors[i]['color'];
                                                break;
                                            }
                                        }
                                    }
                                    else if (tableData.color) {
                                        c['color'] = tableData.color;
                                    }
                                    else if (shadowColor) {
                                        c['color'] = shadowColor;
                                    }
                                    else if (colorByList && colorByList.length > 0) {
                                        c['color'] = colors[index];
                                    }
                                    gridData.push(c);
                                });
                            }
                        });
                        gridOptions = {
                            showTreeExpandNoChildren: false,
                            columnDefs: colDef,
                            rowTemplate: '<div style="text-overflow: ellipsis"' +
                                ' ng-style="{\'color\': row.entity.color }">' +
                                '    <div style="text-overflow: ellipsis" ng-if="!row.entity.merge" ' +
                                '       ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" ' +
                                '       class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" ui-grid-cell>' +
                                '  </div>' +
                                '</div>',
                            data: gridData,
                            showGridFooter: true,
                            gridFooterTemplate: '<div class="ui-grid-bottom-panel" style="text-align: right; color: #939294; font-size: 10px">' +
                                basic_table_component_1.getDate(timestamp) + '</div>'
                        };
                        return gridOptions;
                    }
                    gridLogic.makeSingleTable = makeSingleTable;
                    var getHeaderTooltip = function (displayRules, row) {
                        if (displayRules) {
                            for (var i = 0; i < displayRules.length; i++) {
                                if ((row.displayName == displayRules[i]['ColHeader'] + " (?)") &&
                                    ('Rule' in displayRules[i]) &&
                                    (displayRules[i]['Rule'] == "TOOLTIP")) {
                                    return displayRules[i]['Tooltip'];
                                }
                            }
                        }
                    };
                    function makeMultipleTable(tableData, options, colorByList, colors, shadowColor, displayRules) {
                        if (shadowColor === void 0) { shadowColor = null; }
                        if (displayRules === void 0) { displayRules = null; }
                        var gridOptionList = [];
                        for (var i = 0; i < tableData.length; i++) {
                            gridOptionList.push(makeSingleTable(tableData[i], options, colorByList, colors, shadowColor, displayRules));
                        }
                        return gridOptionList;
                    }
                    gridLogic.makeMultipleTable = makeMultipleTable;
                })(gridLogic = addTables.gridLogic || (addTables.gridLogic = {}));
            })(addTables = acts.addTables || (acts.addTables = {}));
        })(acts = r6.acts || (r6.acts = {}));
    })(r6 = smartorg.r6 || (smartorg.r6 = {}));
})(smartorg || (smartorg = {}));
exports["default"] = smartorg.r6.acts.addTables.gridLogic;
//# sourceMappingURL=grid-logic.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/add-tables/app/js/logic/grid-logic.js